import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    enter(this.backdropTarget)
    enter(this.panelTarget)
  }

  async close(event) {
    if (event.type === "click") {
      event.preventDefault()
    }

    await Promise.all([
      leave(this.backdropTarget),
      leave(this.panelTarget)
    ])

    this.element.remove()
  }
}
